import React from "react";
import translate from "../../../reusable/translate";
import ProgressIconContainer from "./ProgressIconContainer";

const ProgressContainer = React.forwardRef(
  ({ progress, setProgress }, progressContainerRef) => {
    const icons = [
      "NotRelevant",
      "NoProgress",
      "NotAsFast",
      "AsPlanned",
      "Faster",
      "CompletelyAchieved"
    ];

    return (
      <div>
        <p className="p">
          <b>{translate({ textKey: "sit.reporting.progress" })}</b>
        </p>
        <p className="p">
          {translate({ textKey: "sit.reporting.howOperationIsProgressing?" })}
        </p>
        <div ref={progressContainerRef} className="flex-row space-evenly" style={{borderRadius: "5px"}}>
          {icons.map(icon => (
            <ProgressIconContainer
              key={icon}
              icon={icon}
              label={`sit.commitment.reports.${icon}`}
              progress={progress}
              setProgress={setProgress}
            />
          ))}
        </div>
      </div>
    );
  }
);

export default ProgressContainer;



// WEBPACK FOOTER //
// ./src/components/profile/reports/components/ProgressContainer.jsx